<script setup lang="ts"></script>

<template>
  <article class="animate-pulse rounded-lg border border-gray-200 p-4">
    <div class="flex flex-col space-y-3">
      <div>
        <div class="mb-3">
          <div class="h-6 w-48 rounded bg-gray-300" />
        </div>

        <div class="space-y-2 text-sm">
          <div class="flex items-start gap-2">
            <div class="mt-0.5 h-4 w-4 min-w-4 rounded bg-gray-300" />
            <div class="h-4 w-64 rounded bg-gray-300" />
          </div>
        </div>

        <div class="mt-2 flex flex-col gap-4">
          <div class="flex-1 space-y-3">
            <div class="flex flex-wrap gap-1">
              <div class="h-6 w-20 rounded-full bg-gray-300" />
              <div class="h-6 w-16 rounded-full bg-gray-300" />
              <div class="w-18 h-6 rounded-full bg-gray-300" />
            </div>

            <div class="flex flex-wrap gap-2">
              <div class="h-6 w-24 rounded-full bg-gray-300" />
              <div class="h-6 w-20 rounded-full bg-gray-300" />
              <div class="w-22 h-6 rounded-full bg-gray-300" />
              <div class="w-18 h-6 rounded-full bg-gray-300" />
            </div>
          </div>
        </div>
      </div>
    </div>
  </article>
</template>
